import { Injectable, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { combineLatest, Observable, Observer, Subject } from 'rxjs';
import { distinctUntilChanged, filter, map, shareReplay, startWith, switchMap, tap } from 'rxjs/operators';

import { isEqual } from 'lodash-es';

import { BaseContainer } from '@stylehaven/components';
import { EMPTY_OBSERVER } from '../../../helpers/constants';
import { ApiFragment } from '../../entities/api-fragment.entity';
import { RecordSandbox } from './record-sandbox';

@Injectable()
export abstract class RecordContainer extends BaseContainer implements OnInit, OnDestroy {
    readonly refresh$: Subject<void> = new Subject<void>();

    record$!: Observable<ApiFragment>;

    constructor(protected activatedRoute: ActivatedRoute, protected sandbox: RecordSandbox) {
        super();
    }

    ngOnInit(): void {
        this.loading$.startLoading();
        this.record$ = combineLatest([
            this.activatedRoute.params.pipe(distinctUntilChanged(isEqual)),
            this.refresh$.pipe(startWith(undefined))
        ]).pipe(
            map(([params]): string => params.id as string),
            switchMap((recordId: string) => this.sandbox.getRecordById(recordId)),
            startWith(history.state?.record ? new ApiFragment(history.state?.record) : undefined),
            filter((record?: ApiFragment): record is ApiFragment => !!record),
            tap(() => this.loading$.stopLoading()),
            shareReplay({ bufferSize: 1, refCount: true })
        );
    }

    ngOnDestroy() {
        super.ngOnDestroy();

        this.refresh$.complete();
    }

    protected get refreshingObserver(): Observer<boolean> {
        return { ...EMPTY_OBSERVER, next: () => this.refresh$.next() };
    }
}
